import api from './api';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const emailLogService = {
  // Get all email logs
  getEmailLogs: async () => {
    try {
      const response = await api.get('/email-logs');
      return response.data;
    } catch (error) {
      console.error('Error fetching email logs:', error);
      throw error;
    }
  }
};

export default emailLogService;

